import { createClient } from "@supabase/supabase-js";
import { config } from "src/config/environment";

// Service role client for server-side operations that bypass RLS
// This should only be used for operations that require elevated privileges
export const supabaseServiceRole = createClient(
  config.supabase.url,
  // Use service role key from environment variable
  import.meta.env.VITE_SUPABASE_SERVICE_ROLE_KEY || '',
  {
    auth: {
      autoRefreshToken: false,
      persistSession: false
    }
  }
);

// Validate service role key is available
if (!import.meta.env.VITE_SUPABASE_SERVICE_ROLE_KEY) {
  console.warn('⚠️ VITE_SUPABASE_SERVICE_ROLE_KEY is not set. Service role operations will fail.');
}